<app-page-container maxHeight>
  <app-header [paddingBottom]="false" appTitle="Contratos">
    <div class="tab-navegacao">
      <button class="botao__acao" (click)="estaAtivoOuInativo();"
        [ngClass]="{'is-secondary': contratoAtivo, 'is-disabled': !contratoAtivo }"
        [disabled]="contratoAtivo">Ativos</button>
      <button class="botao__acao" (click)="estaAtivoOuInativo();"
        [ngClass]="{'is-secondary': !contratoAtivo, 'is-disabled': contratoAtivo}"
        [disabled]="!contratoAtivo">Inativos</button>
    </div>
    <app-input-pesquisar [(ngModel)]="pesquisar" (buscar)="obterContratos(true)"></app-input-pesquisar>
    <app-checkbox-visualizacao-coluna-tabela
      [colunasTabela]="colunasListagemContratos"></app-checkbox-visualizacao-coluna-tabela>
    <app-botoes-files [disableXLSX]="true"></app-botoes-files>
  </app-header>
  <div class="c-table-container">
    <table class="c-table-container__table" mat-table [dataSource]="contratos.registros">
      <ng-container matColumnDef="codContrato">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="u-border-none c-table-container__table__header-text">Contrato</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"><a
            class="c-table-container__table__link"
            [routerLink]="['detalhes', contrato.codContrato]">{{contrato.codContrato}}</a></td>
      </ng-container>
      <ng-container matColumnDef="tipoContrato">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Tipo do contrato</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{contrato.classificacaoContrato
          || "Sem dados"}} </td>
      </ng-container>
      <ng-container matColumnDef="statusContrato">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Status</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{ contratoAtivo ? 'Ativo' :
          'Inativo'
          || "Sem dados"}} </td>
      </ng-container>
      <ng-container matColumnDef="nomeCliente">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Cliente</div>
        </th>
        <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
        <ng-template #apnetworksCliente>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{contrato.nomeCliente ||
            contrato.nomeFantasiaCliente || 'Sem dados'}}
          </td>
        </ng-template>
        <ng-template #kmDoBrasilCliente>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{contrato.nomeFantasiaCliente
            ||
            contrato.nomeCliente || 'Sem dados'}}
          </td>
        </ng-template>
      </ng-container>
      <ng-container matColumnDef="dataInicioContrato">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Data de início</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{(contrato.dataInicioContrato |
          date: "dd/MM/yyyy") || "Sem dados"}}
        </td>
      </ng-container>
      <ng-container matColumnDef="dataVencimentoContrato">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Vencimento</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{(contrato.dataValidadeContrato
          | date: "dd/MM/yyyy") || "Sem dados"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dataProximoReajusteContrato">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Próximo reajuste</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{(contrato.dataReajusteContrato
          | date: "dd/MM/yyyy") || "Sem dados"
          }} </td>
      </ng-container>
      <ng-container matColumnDef="nomeGrupoEconomicoCliente">
        <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
          <div class="c-table-container__table__header-text">Grupo econômico</div>
        </th>
        <td class="c-table-container__table__cell" mat-cell *matCellDef="let contrato"> {{contrato.nomeGrupoEconomico ||
          "Sem dados"}} </td>
      </ng-container>
      <tr class="c-table-container__table__header-row" mat-header-row *matHeaderRowDef="colunasVisiveis; sticky: true">
      </tr>
      <tr mat-row *matRowDef="let row; columns: colunasVisiveis;"></tr>
    </table>
  </div>
  <app-paginacao nomeDaLista="contratos" [(dados)]="contratos" (dadosChange)="obterContratos()"
    *ngIf="this.contratos.registros.length !== 0"></app-paginacao>
</app-page-container>